export function initMenuOverlay() {
    var menu = document.querySelector('[data-museum-menu]');
    var toggles = document.querySelectorAll('[data-museum-menu-toggle]');
    var closeBtn = document.querySelector('[data-museum-menu-close]');
    var searchInput = document.querySelector('[data-museum-heroes-search-input]');

    if (!menu || !toggles.length) {
        return;
    }

    var panel = menu.querySelector('.museum-menu__panel');
    var links = menu.querySelectorAll('[data-museum-menu-link]');
    var lastFocused = null;
    var mqCarouselMobile = window.matchMedia('(max-width: 1023px)');

    function restoreLastFocus() {
        if (!lastFocused || typeof lastFocused.focus !== 'function') {
            return;
        }

        try {
            lastFocused.focus({ preventScroll: true });
        } catch (err) {
            lastFocused.focus();
        }
    }

    function shouldSkipFocusRestoreOnLinkClick(link) {
        if (!link || !mqCarouselMobile.matches) {
            return false;
        }

        if (!document.querySelector('[data-museum-track]')) {
            return false;
        }

        var href = link.getAttribute('href');

        return !!(href && href.charAt(0) !== '#');
    }

    function syncTogglesExpanded(open) {
        toggles.forEach(function (toggle) {
            toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
    }

    function focusOnOpen(trigger) {
        if (trigger && trigger.hasAttribute('data-museum-menu-focus-search') && searchInput) {
            searchInput.focus();
            return;
        }

        if (closeBtn) {
            closeBtn.focus();
        }
    }

    function setOpen(open, trigger) {
        if (open) {
            lastFocused = document.activeElement;
            menu.hidden = false;
            menu.setAttribute('aria-hidden', 'false');
            syncTogglesExpanded(true);
            document.body.classList.add('museum-menu-open');

            requestAnimationFrame(function () {
                menu.classList.add('is-open');
                focusOnOpen(trigger);
            });

            return;
        }

        menu.classList.remove('is-open', 'is-search-active');
        syncTogglesExpanded(false);
        document.body.classList.remove('museum-menu-open');

        var onEnd = function (event) {
            if (event.target !== panel || event.propertyName !== 'transform') {
                return;
            }

            panel.removeEventListener('transitionend', onEnd);
            menu.hidden = true;
            menu.setAttribute('aria-hidden', 'true');

            restoreLastFocus();
        };

        panel.addEventListener('transitionend', onEnd);

        window.setTimeout(function () {
            if (!menu.hidden) {
                panel.removeEventListener('transitionend', onEnd);
                menu.hidden = true;
                menu.setAttribute('aria-hidden', 'true');
            }
        }, 600);
    }

    toggles.forEach(function (toggle) {
        toggle.addEventListener('click', function () {
            if (toggle.hasAttribute('data-museum-menu-focus-search')) {
                setOpen(true, toggle);
                return;
            }

            var willOpen = !menu.classList.contains('is-open');
            setOpen(willOpen, willOpen ? toggle : null);
        });
    });

    if (closeBtn) {
        closeBtn.addEventListener('click', function () {
            setOpen(false);
        });
    }

    links.forEach(function (link) {
        link.addEventListener('click', function () {
            if (shouldSkipFocusRestoreOnLinkClick(link)) {
                lastFocused = null;
            }

            setOpen(false);
        });
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && menu.classList.contains('is-open')) {
            setOpen(false);
        }
    });
}
